import { ChakraProvider, ColorModeScript, ThemeConfig, extendTheme } from "@chakra-ui/react"
import * as React from "react"
import ReactDOM from "react-dom"
import { BrowserRouter } from "react-router-dom"

import { App } from "./App"
import { Loading } from "./component/Loading"
import { FeatureToggleContainer } from "./container/FeatureToggleContainer"
import { LiquidityMiningServiceContainer } from "./container/LiquidityMiningServiceContainer"
import { Account } from "./module/account"
import { Web3Provider } from "./module/account/container/web3"

declare global {
    interface Window {
        ethereum: any
    }
}
const themeConfig: ThemeConfig = {
    initialColorMode: "dark",
    useSystemColorMode: false,
}
const theme = extendTheme({ config: themeConfig })

ReactDOM.render(
    <React.StrictMode>
        <Web3Provider>
            <Account.Provider>
                <FeatureToggleContainer.Provider>
                    <LiquidityMiningServiceContainer.Provider>
                        <BrowserRouter>
                            <React.Suspense fallback={<Loading />}>
                                <ChakraProvider theme={theme}>
                                    <ColorModeScript />
                                    <App />
                                </ChakraProvider>
                            </React.Suspense>
                        </BrowserRouter>
                    </LiquidityMiningServiceContainer.Provider>
                </FeatureToggleContainer.Provider>
            </Account.Provider>
        </Web3Provider>
    </React.StrictMode>,
    document.getElementById("root"),
)
